import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PricePipe } from '@app/core/pipes/price.pipe';
import { OrderDetails } from '@app/entities/orders/interfaces/order-details';
import { AuthSelectors, CartSelectors, RemoveFromCart } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { sumPrice } from '../sum-price';

@Component({
  selector: 'app-cart-summary',
  templateUrl: './cart-summary.component.html',
  styleUrls: ['./cart-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, PricePipe],
  providers: [CurrencyPipe],
})
export class CartSummaryComponent {
  constructor(private store: Store) {}

  protected termsChecked: boolean = false;

  protected orderDetails$: Observable<OrderDetails | undefined> =
    this.store.select(CartSelectors.orderDetails);

  protected isAuthenticated$: Observable<boolean | undefined> =
    this.store.select(AuthSelectors.isAuthenticated);

  onRemove(itemDetailsId: number): void {
    this.store.dispatch(new RemoveFromCart(itemDetailsId));
  }

  sum(orderDetails: OrderDetails): number {
    return sumPrice(orderDetails);
  }
}
